import '../../scss/ExamDetail.scss'
import { IoMdMenu, IoIosInformationCircleOutline, IoMdExit } from "react-icons/io";
import Navmenudetail from './Navmenudetail';
import React, { useState, useRef, useEffect } from "react";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { ThiTrucTuyenService } from 'services/ThiTrucTuyenService';
import { ProgressSpinner } from 'primereact/progressspinner';
import ExamNoiDetail from './ExamNoiDetail';
import NavInfo from './NavInfo';
import { dethitructuyenService } from 'services/dethitructuyenService';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { overviewService } from 'services/overviewService';
import { setTokenLMS } from 'store/oauth/oauthSlice';
import axios from 'axios';
import { ADMIN_URL } from 'shared/app-settings';
import {
    initExamProgress,
    getExamProgress,
    markExamTypeCompleted,
    getNextExamType,
    isAllExamTypesCompleted,
    getExamTypeRoute
} from 'utils/examProgress';

export default function StartExamNoi() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isAutoLoginInProgress = useRef(false);
    var thitructuyen = localStorage.getItem('thitructuyen');
    var userId = localStorage.getItem('User_Id');
    var typeExam = localStorage.getItem('typeExam');
    var IdDeThi = localStorage.getItem('IdDeThi');
    const username = localStorage.getItem('fullname');

    // Bỏ qua guard nếu đang trong quá trình auto-login (localStorage đã bị clear)
    if (!isAutoLoginInProgress.current && (IdDeThi == null || IdDeThi == "" || userId == null || username == "" || username == null)) {
        window.location.href = '/'
    }
    const [visibleInFo, setVisibleInFo] = useState(false);
    const [visible, setVisible] = useState(false);
    const [arrIdNhomQuestion, setarrIdNhomQuestion] = useState([]);
    const [indexDF, setIndexDF] = useState(0);
    const [indexNhom, setIndexNhom] = useState(0);
    const [dataQuestion, setdataQuestion] = useState([]);
    const [dataListQuestion, setdataListQuestion] = useState([]);
    const [loading, setLoading] = useState(false);
    const [socauhoi, setSoCauHoi] = useState(0);
    const [sonhomcauhoi, setSoNhomCauHoi] = useState(0);
    const [motadau, setmotadau] = useState('');
    const [motacuoi, setmotacuoi] = useState('');
    const [fileDinhKem, setFileDinhKem] = useState('');
    const [isNhom, setIsNhom] = useState(false);
    const [showQuestion, setshowQuestion] = useState(false);
    const [arrIdQuestion, setarrIdQuestion] = useState([]);
    const [type, setType] = useState("");
    const [showForceFullscreen, setShowForceFullscreen] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    const [showSpeakingComplete, setShowSpeakingComplete] = useState(false);
    const [logoutCountdown, setLogoutCountdown] = useState(5);
    // Auto-login states
    const [showAutoLogin, setShowAutoLogin] = useState(false);
    const [autoLoginMsg, setAutoLoginMsg] = useState('Đang chuẩn bị chuyển sang các kỹ năng khác...');
    const [autoLoginDots, setAutoLoginDots] = useState(0);
    const audioRef = useRef(null);

    const openDetailMenu = () => {
        setVisible(true);
    }

    const onCloseDetailMenu = () => {
        setVisible(false);
    }

    const toast = useRef(null);

    const accept = () => {
        toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
    }

    const reject = () => {
        // toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    }

    const toggleAudio = async () => {
        try {
            const el = audioRef.current;
            if (!el) return;

            const currentIdNhom = arrIdNhomQuestion[indexNhom]?.idnhom || 'no_group';
            const playCountKey = `playCount_${userId}_nhom_${currentIdNhom}_${IdDeThi}`;
            const currentCount = parseInt(localStorage.getItem(playCountKey) || '0');

            if (isPlaying) {
                el.pause();
                setIsPlaying(false);
            } else {
                if (currentCount >= 2) {
                    toast.current.show({
                        severity: 'warn',
                        summary: 'Thông báo',
                        detail: 'Bạn đã hết lượt nghe cho nhóm câu hỏi này (tối đa 2 lần).',
                        life: 3000
                    });
                    return;
                }

                // Nếu bắt đầu nghe (lượt 1 hoặc 2), thì nghe lại từ đầu
                el.currentTime = 0;
                await el.play();
                setIsPlaying(true);

                const newCount = currentCount + 1;
                localStorage.setItem(playCountKey, newCount);
            }
        } catch (e) {
            // ignore play error
        }
    };

    // Tự động tính lượt nghe đầu tiên khi autoPlay
    useEffect(() => {
        if (fileDinhKem && fileDinhKem !== '' && fileDinhKem != null) {
            const currentIdNhom = arrIdNhomQuestion[indexNhom]?.idnhom || 'no_group';
            const playCountKey = `playCount_${userId}_nhom_${currentIdNhom}_${IdDeThi}`;
            const currentCount = parseInt(localStorage.getItem(playCountKey) || '0');
            if (currentCount === 0) {
                localStorage.setItem(playCountKey, '1');
            }
        }
    }, [fileDinhKem, indexNhom]);

    // Sync state khi audio play/pause (cho autoPlay)
    useEffect(() => {
        const audioEl = audioRef.current;
        if (!audioEl) return;

        const handlePlay = () => setIsPlaying(true);
        const handlePause = () => setIsPlaying(false);
        const handleEnded = () => setIsPlaying(false);

        audioEl.addEventListener('play', handlePlay);
        audioEl.addEventListener('pause', handlePause);
        audioEl.addEventListener('ended', handleEnded);

        // Nếu audio đã đang phát (autoPlay trigger trước khi listener được gắn)
        if (!audioEl.paused) {
            setIsPlaying(true);
        }

        // Delay check: autoPlay có thể chưa trigger ngay khi element vừa mount
        const timer = setTimeout(() => {
            if (audioEl && !audioEl.paused) {
                setIsPlaying(true);
            }
        }, 150);

        return () => {
            clearTimeout(timer);
            audioEl.removeEventListener('play', handlePlay);
            audioEl.removeEventListener('pause', handlePause);
            audioEl.removeEventListener('ended', handleEnded);
        };
    }, [fileDinhKem, indexNhom, loading]);

    const confirmExit = () => {
        confirmDialog({
            message: 'Are you sure you want to proceed?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            accept,
            reject
        });
    };

    // Helper function: Tìm nhóm câu hỏi và câu hỏi đầu tiên chưa có đáp án (cho NOI)
    const findFirstUnansweredQuestionNoi = async (questionIdList, userId) => {
        if (!questionIdList || questionIdList.length === 0) {
            return { nhomIndex: -1, questionIndex: -1 };
        }

        // Kiểm tra từng nhóm câu hỏi
        for (let nhomIdx = 0; nhomIdx < questionIdList.length; nhomIdx++) {
            const item = questionIdList[nhomIdx];

            // Nếu là nhóm câu hỏi (object có idnhom)
            if (typeof item === 'object' && item.idnhom) {
                try {
                    // Load danh sách câu hỏi trong nhóm này
                    // Chỉ gửi attempt_code nếu có (để backend check Redis)
                    const attemptCode = localStorage.getItem('exam_attempt_code');
                    const result = await ThiTrucTuyenService.getquestionbyidnhom(item.idnhom, userId, thitructuyen, attemptCode);
                    const lstCauHoi = result?.data?.data?.LstCauHoi || [];

                    // Kiểm tra từng câu hỏi trong nhóm
                    for (let qIdx = 0; qIdx < lstCauHoi.length; qIdx++) {
                        const cauHoi = lstCauHoi[qIdx];
                        const cauHoiId = cauHoi?.id;

                        if (!cauHoiId) continue;

                        // Kiểm tra xem câu hỏi này đã có đáp án chưa
                        // Chỉ gửi attempt_code nếu có (để backend check Redis)
                        const attemptCode = localStorage.getItem('exam_attempt_code');
                        const detailResult = await ThiTrucTuyenService.getdetailquestion(cauHoiId, userId, attemptCode);
                        const selected = detailResult?.data?.data?.selected;

                        // Nếu không có selected hoặc selected rỗng/null, đây là câu hỏi đầu tiên chưa làm
                        if (!selected ||
                            (selected.id_cautraloi === null && !selected.vanbantraloi) ||
                            (Array.isArray(selected.id_cautraloi) && selected.id_cautraloi.length === 0)) {
                            return { nhomIndex: nhomIdx, questionIndex: qIdx };
                        }
                    }
                } catch (error) {
                    console.error(`Error checking nhom ${item.idnhom}:`, error);
                    continue;
                }
            } else {
                // Nếu là câu hỏi đơn lẻ
                try {
                    // Chỉ gửi attempt_code nếu có (để backend check Redis)
                    const attemptCode = localStorage.getItem('exam_attempt_code');
                    const result = await ThiTrucTuyenService.getdetailquestion(item, userId, attemptCode);
                    const selected = result?.data?.data?.selected;

                    if (!selected ||
                        (selected.id_cautraloi === null && !selected.vanbantraloi) ||
                        (Array.isArray(selected.id_cautraloi) && selected.id_cautraloi.length === 0)) {
                        return { nhomIndex: nhomIdx, questionIndex: 0 };
                    }
                } catch (error) {
                    console.error(`Error checking question ${item}:`, error);
                    continue;
                }
            }
        }

        // Nếu tất cả đều có đáp án, trả về -1
        return { nhomIndex: -1, questionIndex: -1 };
    };
    const onsubmitexam = async () => {
        const typeExam = localStorage.getItem('typeExam');
        const attemptCode = localStorage.getItem('exam_attempt_code');
        const IdThongTinUser = localStorage.getItem('IdThongTinUser') || null;

        // Đồng bộ dữ liệu về DB ngay khi kết thúc 1 dạng bài (Speaking)
        try {
            if (IdThongTinUser) {
                await ThiTrucTuyenService.updatethongtinuser({
                    id: IdThongTinUser,
                    time_con_lai: localStorage.getItem('countDown') || null,
                    attempt_code: attemptCode || null,
                    type_exam: typeExam
                });
            }
        } catch (e) {
            console.error('updatethongtinuser (sync per skill) error', e);
        }

        // ========== TRIGGER AI CHẤM ĐIỂM SPEAKING ==========
        // PHẢI await trước khi navigate — nếu fire & forget, browser sẽ cancel
        // request khi chuyển trang, dẫn đến dữ liệu không được đẩy vào Redis Queue.
        if (typeExam === 'NOI' && userId && attemptCode) {
            try {
                const aiRes = await ThiTrucTuyenService.submitSpeakingAI(userId, attemptCode, typeExam);
                const requestId = aiRes?.data?.request_id || aiRes?.data?.job_id;
                if (requestId) {
                    localStorage.setItem('ai_speaking_request_id', requestId);
                    console.info('[AI Speaking] Submitted OK, requestId:', requestId);
                }
            } catch (err) {
                // Không alert user — chỉ log để admin theo dõi
                console.warn('[AI Speaking] Submit failed (non-blocking):', err?.message);
            }
        }
        // =====================================================================

        // Đánh dấu dạng thi hiện tại đã hoàn thành
        markExamTypeCompleted(typeExam);

        // Phase 1 (speaking_only): sau khi hoàn thành Nói → thoát fullscreen và auto-login
        const examMode = localStorage.getItem('exam_mode');
        if (examMode === 'speaking_only') {
            // Đánh dấu đang auto-login TRƯỚC khi thoát fullscreen
            // để event fullscreenchange không trigger popup "Yêu cầu toàn màn hình"
            isAutoLoginInProgress.current = true;
            setShowForceFullscreen(false);
            try {
                if (document.fullscreenElement) {
                    await document.exitFullscreen();
                }
            } catch (e) { /* ignore */ }
            setShowAutoLogin(true);
            await performAutoLogin();
            return;
        }

        // Phase 2: Kiểm tra xem còn dạng thi nào chưa thi không
        if (isAllExamTypesCompleted()) {
            // Đã thi hết tất cả, chuyển đến màn tổng hợp điểm
            navigate('/resultexam', { state: { isFinalResult: true } });
        } else {
            // Còn dạng khác, chuyển sang dạng tiếp theo
            const nextExamType = getNextExamType();
            if (nextExamType) {
                localStorage.setItem('typeExam', nextExamType);
                const nextRoute = getExamTypeRoute(nextExamType);
                navigate(nextRoute);
            } else {
                // Fallback: nếu không tìm được dạng tiếp theo, chuyển đến màn tổng hợp
                navigate('/resultexam', { state: { isFinalResult: true } });
            }
        }
    }


    const confirmSubmit = () => {
        confirmDialog({
            message: (
                <p style={{ padding: '0 10px', margin: 0, fontSize: 14.5, lineHeight: 1.7, color: '#374151' }}>
                    Once you submit your test you will no longer have access to the questions.
                </p>
            ),
            header: 'Submit Test?',
            closable: false,
            defaultFocus: 'reject',
            acceptLabel: 'Submit test',
            rejectLabel: 'Cancel',
            accept: onsubmitexam,
        });
    };


    // Ngăn chặn công cụ tìm kiếm trình duyệt (Ctrl+F, Ctrl+F3) trong lúc thi
    useEffect(() => {
        const blockSearchShortcuts = (e) => {
            if (e.ctrlKey && (e.key === 'f' || e.key === 'F' || e.key === 'F3')) {
                e.preventDefault();
                e.stopPropagation();
            }
            if (e.key === 'F3') {
                e.preventDefault();
                e.stopPropagation();
            }
        };
        document.addEventListener('keydown', blockSearchShortcuts, true);
        return () => {
            document.removeEventListener('keydown', blockSearchShortcuts, true);
        };
    }, []);

    // Best-effort: cố gắng giữ fullscreen trong màn StartExamNoi
    useEffect(() => {
        // Đánh dấu đang trong màn thi để tự động bật lại fullscreen sau khi reload
        sessionStorage.setItem('exam_fullscreen_required', 'true');

        // Kiểm tra ngay khi mount: nếu không ở fullscreen → hiện Dialog
        const initTimer = setTimeout(() => {
            if (!document.fullscreenElement) {
                setShowForceFullscreen(true);
            }
        }, 300);

        // Khi trạng thái fullscreen thay đổi → kiểm tra ngay
        const onFsChange = () => {
            // Không hiện popup khi đang auto-login (thoát fullscreen có chủ ý)
            if (isAutoLoginInProgress.current) {
                setShowForceFullscreen(false);
                return;
            }
            if (document.fullscreenElement) {
                setShowForceFullscreen(false);
            } else {
                // Thoát fullscreen → hiện Dialog yêu cầu bật lại ngay lập tức
                setShowForceFullscreen(true);
            }
        };
        document.addEventListener('fullscreenchange', onFsChange);

        // Polling: kiểm tra định kỳ mỗi 1 giây (đề phòng event bị miss)
        const pollInterval = setInterval(() => {
            // Không kiểm tra khi đang auto-login (đã thoát fullscreen có chủ ý)
            if (isAutoLoginInProgress.current) return;
            if (!document.fullscreenElement) {
                setShowForceFullscreen(true);
            } else {
                setShowForceFullscreen(false);
            }
        }, 1000);

        return () => {
            clearTimeout(initTimer);
            clearInterval(pollInterval);
            document.removeEventListener('fullscreenchange', onFsChange);
        };
    }, []);


    useEffect(() => {
        loadData();
    }, []);


    const loadData = async () => {
        var typeExam = localStorage.getItem('typeExam');
        setType(typeExam);

        // Khởi tạo progress nếu chưa có hoặc đề thi khác
        const progress = getExamProgress();
        const currentDethiId = String(IdDeThi || '');
        const progressDethiId = progress ? String(progress.dethiId || '') : '';

        // Kiểm tra xem đã có lượt thi với attempt_code + type_exam + dethitructuyen_id chưa
        let attemptCode = localStorage.getItem('exam_attempt_code');
        let isExistingAttempt = false;

        if (attemptCode) {
            try {
                const checkResult = await ThiTrucTuyenService.checkattempt({
                    user_id: userId,
                    dethitructuyen_id: IdDeThi,
                    type_exam: typeExam,
                    attempt_code: attemptCode
                });
                isExistingAttempt = checkResult?.data?.exists === true;
            } catch (e) {
                console.error('checkattempt error', e);
            }
        }

        // Nếu chưa có progress hoặc đề khác → khởi tạo progress mới
        if (!progress || progressDethiId !== currentDethiId || !progressDethiId) {
            // Nếu đã có lượt thi với attempt_code này thì clear đáp án cũ
            if (isExistingAttempt) {
                try {
                    await ThiTrucTuyenService.clearndata({ userId: userId, IdDeThi: IdDeThi });
                } catch (e) {
                    console.error('clearndata error', e);
                }
            }

            initExamProgress(IdDeThi);

            // Khôi phục completedTypes từ database:
            // - Resume session (có attempt_code chưa hoàn thành)
            // - Hoặc Phase 2 (full_exam): cần đánh dấu NOI đã xong từ Phase 1
            const needsRestore = (attemptCode && !isExistingAttempt) || localStorage.getItem('exam_mode') === 'full_exam';
            if (needsRestore) {
                try {
                    const resumeRes = await ThiTrucTuyenService.checkResumeAttempt({
                        user_id: userId,
                        dethitructuyen_id: IdDeThi
                    });
                    const dataResume = resumeRes?.data;
                    if (dataResume?.completed_types?.length > 0 && !dataResume?.is_fully_completed) {
                        const restoredProgress = getExamProgress();
                        if (restoredProgress) {
                            // Đánh dấu các dạng đã hoàn thành từ database (bao gồm NOI từ Phase 1)
                            dataResume.completed_types.forEach(type => {
                                markExamTypeCompleted(type);
                            });
                        }
                    }
                } catch (e) {
                    console.error('Restore progress from DB error', e);
                }
            }
        }

        let body = {
            typeExam: typeExam,
            isthitructuyen: 1,
            userId: userId,
            IdDeThi: IdDeThi,
            kyThiId: localStorage.getItem('CaThiId') || localStorage.getItem('KyThiId') || null
        }
        let result = await ThiTrucTuyenService.getdetailexam(body);
        const dataExam = result?.data || {};

        // Không có nhóm câu hỏi → báo và dừng
        if (!Array.isArray(dataExam.dataId) || dataExam.dataId.length === 0) {
            toast.current?.show({
                severity: 'warn',
                summary: 'Thông báo',
                detail: 'Đề thi hiện không có câu hỏi Speaking nào. Vui lòng liên hệ quản trị viên.',
                life: 5000
            });
            setLoading(false);
            return;
        }

        setarrIdNhomQuestion(dataExam.dataId);
        setSoNhomCauHoi(dataExam.dataId.length);
        setarrIdQuestion(dataExam.dataId);
        localStorage.setItem('arrIdCauHoi', dataExam.dataId);
        localStorage.setItem('indexNhomDF', indexDF);

        // Tìm nhóm câu hỏi và câu hỏi đầu tiên chưa có đáp án (để resume)
        let startNhomIndex = 0;
        let startQuestionIndex = 0;

        if (attemptCode) {
            // Nếu có attempt_code, tìm nhóm và câu hỏi đầu tiên chưa có đáp án
            const found = await findFirstUnansweredQuestionNoi(result.data.dataId, userId);
            if (found.nhomIndex !== -1) {
                startNhomIndex = found.nhomIndex;
                startQuestionIndex = found.questionIndex;
            }
        }

        setIndexNhom(startNhomIndex);
        setIndexDF(startQuestionIndex);

        // Load nhóm câu hỏi đầu tiên chưa hoàn thành
        const firstItem = result.data.dataId[startNhomIndex];
        if (firstItem && typeof firstItem === 'object' && firstItem.idnhom) {
            // Nếu là nhóm câu hỏi, load nhóm đó trước
            const attemptCode = localStorage.getItem('exam_attempt_code');
            const nhomResult = await ThiTrucTuyenService.getquestionbyidnhom(firstItem.idnhom, userId, thitructuyen, attemptCode);
            const lstCauHoi = nhomResult?.data?.data?.LstCauHoi || [];

            // Set dữ liệu nhóm
            setdataListQuestion(lstCauHoi);
            setmotadau(nhomResult?.data?.data?.des || '');
            setmotacuoi(nhomResult?.data?.data?.des_cuoi || '');
            setFileDinhKem(nhomResult?.data?.data?.file || '');
            setIsNhom(true);
            setSoCauHoi(lstCauHoi.length);

            // Nếu cần set câu hỏi cụ thể trong nhóm
            if (startQuestionIndex > 0 && lstCauHoi[startQuestionIndex]) {
                setdataQuestion(lstCauHoi[startQuestionIndex]);
                setshowQuestion(true);
                setIsNhom(false);
                setIndexDF(startQuestionIndex);
            }
        } else if (firstItem && (typeof firstItem === 'string' || typeof firstItem === 'number')) {
            // Nếu là câu hỏi đơn lẻ
            await loadDataQuestion(firstItem);
        } else {
            // Fallback: dùng logic cũ
            await getCurrentQuestion(result.data.dataId, startNhomIndex, 'default');
        }

        // Lưu thông tin lượt thi cho kỹ năng Speaking
        await addThongTinUser();
    }

    const addThongTinUser = async () => {
        let attemptCode = localStorage.getItem('exam_attempt_code');
        if (!attemptCode) {
            attemptCode = `ATT_${userId}_${IdDeThi}_${Date.now()}`;
            localStorage.setItem('exam_attempt_code', attemptCode);
        }
        const attemptOrder = 5; // Speaking

        const body = {
            type_exam: localStorage.getItem('typeExam'),
            user_id: userId,
            dethitructuyen_id: IdDeThi,
            dethitructuyen_name: localStorage.getItem('TenDeThi') || null,
            attempt_code: attemptCode,
            attempt_order: attemptOrder
        };
        const result = await ThiTrucTuyenService.addthongtinuser(body);
        if (result?.data?.newId) {
            localStorage.setItem('IdThongTinUser', result.data.newId);
        }
    };

    const onSubmitAnswer = async (answerData) => {
        try {
            // Submit answer với audio URL
            await ThiTrucTuyenService.submitquestiontuluan(answerData);
        } catch (error) {
            console.error('Submit answer error:', error);
        }
    };

    // Auto-next: tự động chuyển câu/nhóm tiếp theo
    const handleAutoNext = () => {
        getCurrentQuestion(arrIdQuestion, indexDF, 'next');
    };

    const getCurrentQuestion = async (questionIdList, index, typeBtn = '') => {
        if (typeBtn == 'next') {
            if (isNhom) {
                setLoading(true);
                setshowQuestion(true);
                let _dataquestion = dataListQuestion[index];
                setdataQuestion(_dataquestion);
                setIsNhom(false);
            }
            else if (!isNhom && showQuestion && index < socauhoi - 1) {
                // Chưa đến câu cuối cùng trong nhóm, chuyển sang câu tiếp theo
                // Lưu ý: Submit đáp án được xử lý trong ExamNoiDetail component
                setLoading(true);
                index++;
                let _dataquestion = dataListQuestion[index];
                setdataQuestion(_dataquestion);
                setIndexDF(index);
            }
            else {
                // Đã đến câu cuối cùng trong nhóm hiện tại
                // Lưu ý: Submit đáp án của câu cuối cùng được xử lý trong ExamNoiDetail component
                let _indexNhom = indexNhom;
                let _arrIdNhomQuestion = arrIdNhomQuestion;
                if (_indexNhom < _arrIdNhomQuestion.length - 1) {
                    // Còn nhóm tiếp theo, chuyển sang nhóm tiếp theo
                    setLoading(true);
                    _indexNhom++;
                    setIndexNhom(_indexNhom);
                    setshowQuestion(false);
                    setIndexDF(0);
                    await loadDataQuestionByIdNhom(_arrIdNhomQuestion[_indexNhom].idnhom);
                }
                else {
                    // Đã đến nhóm cuối cùng và câu cuối cùng, gọi confirmSubmit
                    // Không setLoading để giữ nguyên giao diện, tránh re-render ghi âm
                    confirmSubmit();
                    return;
                }
            }

        }
        if (typeBtn == 'prev') {
            if (isNhom) {
                setshowQuestion(true);
                let _dataquestion = dataListQuestion[index];
                setdataQuestion(_dataquestion);
                setIsNhom(false);
            }
            else if (!isNhom && showQuestion && index < socauhoi - 1) {
                index--;
                let _dataquestion = dataListQuestion[index];
                setdataQuestion(_dataquestion);
                setIndexDF(index);
            }
            else {
                setLoading(true);
                let _indexNhom = indexNhom;
                let _arrIdNhomQuestion = arrIdNhomQuestion;
                _indexNhom--;
                setIndexNhom(_indexNhom);
                setshowQuestion(false);
                setIndexDF(0);
                await loadDataQuestionByIdNhom(_arrIdNhomQuestion[_indexNhom].idnhom)
            }
        }
        if (typeBtn == 'submit') {

        }
        if (typeBtn == 'default') {
            setLoading(true);
            if (typeof questionIdList[index] === 'string' || typeof questionIdList[index] === 'number') {
                await loadDataQuestion(questionIdList[index]);
            }
            else {
                setIndexNhom(0);
                await loadDataQuestionByIdNhom(questionIdList[index].idnhom)
            }
        }
        setTimeout(() => {
            setLoading(false);
        }, 1000);

    }

    const loadDataQuestion = async (IdCauHoi) => {
        setLoading(true);
        // Chỉ gửi attempt_code nếu có (để backend check Redis)
        const attemptCode = localStorage.getItem('exam_attempt_code');
        let result = await ThiTrucTuyenService.getdetailquestion(IdCauHoi, userId, attemptCode);
        setdataQuestion(result.data.data);
        setFileDinhKem("");
        setIsNhom(false);
    }
    const loadDataQuestionByIdNhom = async (IdNhom) => {
        setLoading(true);
        try {
            // Chỉ gửi attempt_code nếu có (để backend check Redis)
            const attemptCode = localStorage.getItem('exam_attempt_code');
            let result = await ThiTrucTuyenService.getquestionbyidnhom(IdNhom, userId, thitructuyen, attemptCode);
            setdataListQuestion(result.data.data.LstCauHoi);
            setmotadau(result.data.data.des);
            setmotacuoi(result.data.data.des_cuoi);
            setFileDinhKem(result.data.data.file);
            setIsNhom(true);
            setSoCauHoi(result.data.data.LstCauHoi.length);
        } catch (error) {
            console.error('loadDataQuestionByIdNhom error:', error);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 500);
        }
    }
    const openMenuLeft = async (val, idx) => {
        if (typeof val == 'string' || typeof val == 'number') {
            await loadDataQuestion(val);
            setIndexNhom(idx);
        }
        else {
            setshowQuestion(false);
            setIndexDF(0);
            setIndexNhom(idx);
            await loadDataQuestionByIdNhom(val.idnhom);
        }
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }

    // Handler thoát sau khi hoàn thành Phase 1 (fallback nếu auto-login thất bại)
    const handleSpeakingComplete = () => {
        localStorage.clear();
        sessionStorage.clear();
        navigate('/', { replace: true });
    };

    // Auto-login sau khi hoàn thành Phase 1 (Speaking)
    const performAutoLogin = async () => {
        try {
            // Lưu lại thông tin cần thiết trước khi clear
            const savedEmail = localStorage.getItem('email');
            const savedCaThiId = localStorage.getItem('CaThiId');
            const savedCaThiName = localStorage.getItem('CaThiName');
            const savedIdDeThi = localStorage.getItem('IdDeThi');
            const savedKyThiId = localStorage.getItem('KyThiId');
            const savedKyThiName = localStorage.getItem('KyThiName');
            const savedPhongThiId = localStorage.getItem('PhongThiId');
            const savedPhongThiName = localStorage.getItem('PhongThiName');
            const savedTenDeThi = localStorage.getItem('TenDeThi');

            if (!savedEmail) {
                // Nếu không có email, fallback về màn hình thông thường
                setShowAutoLogin(false);
                setShowSpeakingComplete(true);
                return;
            }

            // Bước 1: Đăng xuất
            setAutoLoginMsg('Đang đăng xuất...');
            await new Promise(r => setTimeout(r, 800));
            // Đánh dấu đang auto-login để bỏ qua guard check redirect
            isAutoLoginInProgress.current = true;
            localStorage.clear();
            sessionStorage.clear();

            // Bước 2: Đăng nhập lại
            setAutoLoginMsg('Đang đăng nhập lại...');
            await new Promise(r => setTimeout(r, 600));

            const response = await overviewService.login(savedEmail, '123456');

            if (!response?.data?.status) {
                throw new Error(response?.data?.message || 'Login failed');
            }

            // Bước 3: Lưu credentials mới
            const userData = response.data.data || response.data.user;
            const accessToken = response.data.access_token;

            if (userData) {
                localStorage.setItem('User_Id', userData.uid || userData.id || '');
                localStorage.setItem('email', userData.email || savedEmail);
                localStorage.setItem('fullname', userData.fullname || userData.full_name || '');
                if (userData.phone) localStorage.setItem('phone', userData.phone);
                if (userData.ngay_sinh) localStorage.setItem('ngay_sinh', userData.ngay_sinh);
            }
            if (accessToken) {
                localStorage.setItem('access_token', accessToken);
                dispatch(setTokenLMS(accessToken));
            }

            // Bước 4: Khôi phục dữ liệu ca thi
            if (savedCaThiId) localStorage.setItem('CaThiId', savedCaThiId);
            if (savedCaThiName) localStorage.setItem('CaThiName', savedCaThiName);
            if (savedIdDeThi) localStorage.setItem('IdDeThi', savedIdDeThi);
            if (savedKyThiId) localStorage.setItem('KyThiId', savedKyThiId);
            if (savedKyThiName) localStorage.setItem('KyThiName', savedKyThiName);
            if (savedPhongThiId) localStorage.setItem('PhongThiId', savedPhongThiId);
            if (savedPhongThiName) localStorage.setItem('PhongThiName', savedPhongThiName);
            if (savedTenDeThi) localStorage.setItem('TenDeThi', savedTenDeThi);

            // Bước 5: Thiết lập Phase 2 — xác định dạng bài tiếp theo ĐỘNG (không hardcode)
            localStorage.setItem('exam_mode', 'full_exam');
            localStorage.setItem('arrBookMark', JSON.stringify([]));

            // Khôi phục/khởi tạo progress từ DB (giống logic OverviewExam)
            let nextExamType = 'NGUPHAP'; // fallback mặc định
            try {
                const resumeRes = await ThiTrucTuyenService.checkResumeAttempt({
                    user_id: userData?.uid || userData?.id || localStorage.getItem('User_Id'),
                    dethitructuyen_id: savedIdDeThi
                });
                const completedTypes = resumeRes?.data?.completed_types || ['NOI'];

                // Khởi tạo progress và đánh dấu các dạng đã hoàn thành
                initExamProgress(savedIdDeThi);
                completedTypes.forEach(t => markExamTypeCompleted(t));

                const detected = getNextExamType();
                if (detected) nextExamType = detected;
            } catch (e) {
                // Fallback: mark NOI xong và lấy next
                initExamProgress(savedIdDeThi);
                markExamTypeCompleted('NOI');
                const detected = getNextExamType();
                if (detected) nextExamType = detected;
                console.warn('[AutoLogin] checkResumeAttempt failed, fallback nextExamType:', nextExamType);
            }

            localStorage.setItem('typeExam', nextExamType);

            // Bước 6: Lấy thời gian dạng bài để set countDown
            setAutoLoginMsg('Đang chuẩn bị bài thi tiếp theo...');
            try {
                const detailRes = await axios.get(
                    ADMIN_URL + 'detail-dangbai',
                    {
                        params: {
                            code: nextExamType,
                            kyThiId: savedCaThiId || savedKyThiId || null
                        },
                        headers: { Authorization: `${accessToken}` }
                    }
                );
                const thoigian = parseInt(detailRes?.data?.data?.thoigian || 0);
                if (thoigian > 0) {
                    localStorage.setItem('countDown', thoigian * 60);
                }
            } catch (e) {
                console.warn('[AutoLogin] Không lấy được countDown:', e?.message);
            }

            // Bước 7: Chuyển thẳng vào màn thi (bỏ qua OverviewExam)
            setAutoLoginMsg('Đang chuyển hướng sang các kỹ năng khác...');
            await new Promise(r => setTimeout(r, 800));

            navigate('/examdetail', { replace: true });

        } catch (error) {
            console.error('[AutoLogin] Error:', error);
            // Fallback: hiện màn hình manual logout
            setShowAutoLogin(false);
            setShowSpeakingComplete(true);
        }
    };

    // Hiệu ứng dấu chấm chờ cho loading
    useEffect(() => {
        if (!showAutoLogin) return;
        const interval = setInterval(() => {
            setAutoLoginDots(d => (d + 1) % 4);
        }, 400);
        return () => clearInterval(interval);
    }, [showAutoLogin]);

    return (
        <>
            {/* Màn Auto-Login Loading - chuyển Phase 1 → Phase 2 */}
            {showAutoLogin && (
                <div style={{
                    position: 'fixed', inset: 0,
                    background: '#ffffff',
                    display: 'flex', flexDirection: 'column',
                    alignItems: 'center', justifyContent: 'center',
                    zIndex: 99999, textAlign: 'center', padding: '24px',
                    fontFamily: 'system-ui, -apple-system, sans-serif'
                }}>
                    {/* Icon check */}
                    <div style={{
                        width: 80, height: 80, borderRadius: '50%',
                        background: 'rgba(35,8,90,0.08)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        marginBottom: 28, fontSize: 36
                    }}>
                        🎤
                    </div>

                    {/* Tiêu đề */}
                    <h2 style={{
                        color: '#23085a', fontSize: 22, fontWeight: 700,
                        marginBottom: 10, letterSpacing: 0.3
                    }}>
                        Speaking Completed!
                    </h2>

                    {/* Thông báo trạng thái */}
                    <p style={{
                        color: '#6b7280', fontSize: 15,
                        marginBottom: 32, minHeight: 24
                    }}>
                        {/* {autoLoginMsg}{Array(autoLoginDots + 1).join('.')} */}
                        Đang chuyển sang các kỹ năng khác...
                    </p>

                    {/* Spinner */}
                    <div style={{ marginBottom: 32 }}>
                        <div style={{
                            width: 48, height: 48,
                            border: '4px solid rgba(35,8,90,0.15)',
                            borderTopColor: '#23085a',
                            borderRadius: '50%',
                            animation: 'spin 0.9s linear infinite',
                            margin: '0 auto'
                        }} />
                    </div>

                    {/* Step indicators */}
                    <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
                        {['Nói', 'Ngữ pháp', 'Nghe', 'Đọc', 'Viết'].map((skill, i) => (
                            <div key={i} style={{
                                padding: '6px 14px',
                                borderRadius: 20,
                                fontSize: 13, fontWeight: 600,
                                background: i === 0
                                    ? 'rgba(255,255,255,0.25)'
                                    : 'rgba(255,255,255,0.08)',
                                color: i === 0 ? '#fff' : 'rgba(255,255,255,0.5)',
                                border: i === 0
                                    ? '1.5px solid rgba(255,255,255,0.5)'
                                    : '1.5px solid rgba(255,255,255,0.15)',
                                textDecoration: i === 0 ? 'line-through' : 'none'
                            }}>
                                {i === 0 ? '✓ ' : ''}{skill}
                            </div>
                        ))}
                    </div>

                    <style>{`
                        @keyframes spin {
                            from { transform: rotate(0deg); }
                            to { transform: rotate(360deg); }
                        }
                    `}</style>
                </div>
            )}

            {/* Màn hoàn thành Phase 1 - fallback nếu auto-login thất bại */}
            {showSpeakingComplete && (
                <div style={{
                    position: 'fixed', inset: 0,
                    background: '#fff',
                    display: 'flex', flexDirection: 'column',
                    alignItems: 'center', justifyContent: 'center',
                    zIndex: 99999, textAlign: 'center', padding: '24px',
                    fontFamily: 'system-ui, -apple-system, sans-serif'
                }}>
                    <div style={{ fontSize: 64, marginBottom: 16, color: '#23085a' }}>
                        👍
                    </div>
                    <p style={{ fontSize: 17, color: '#6b7280', marginBottom: 28 }}>
                        The Speaking test is complete. Please log in again to proceed with the next skills tests.
                    </p>
                    <button
                        onClick={handleSpeakingComplete}
                        style={{
                            background: '#23085a', color: '#fff',
                            border: 'none', borderRadius: 8,
                            padding: '12px 28px', fontSize: 15, fontWeight: 600,
                            cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8
                        }}
                    >
                        Log out <span>→</span>
                    </button>
                </div>
            )}

            {/* Overlay chặn toàn bộ tương tác khi không ở fullscreen */}
            {showForceFullscreen && (
                <div style={{
                    position: 'fixed',
                    inset: 0,
                    zIndex: 999999,
                    background: 'rgba(0, 0, 0, 0.6)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <div style={{
                        background: '#fff',
                        borderRadius: 16,
                        width: 'min(560px, 95vw)',
                        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
                        overflow: 'hidden',
                    }}>
                        {/* Header */}
                        <div style={{
                            padding: '20px 24px 12px',
                            fontSize: 17,
                            fontWeight: 700,
                            color: '#1e1b4b',
                        }}>
                            Yêu cầu chế độ toàn màn hình
                        </div>
                        {/* Body */}
                        <div style={{ padding: '0 24px 20px' }}>
                            <div style={{ display: 'flex', gap: 14, lineHeight: 1.5 }}>
                                <div style={{
                                    width: 44, height: 44, borderRadius: 12,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    background: 'rgba(35, 8, 90, 0.08)', color: '#23085a', flex: '0 0 auto'
                                }}>
                                    <i className="pi pi-window-maximize" style={{ fontSize: 18 }} />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <div style={{ fontSize: 16, fontWeight: 700, color: '#111827', marginBottom: 6 }}>
                                        Vui lòng bật chế độ toàn màn hình để tiếp tục
                                    </div>
                                    <div style={{ fontSize: 14, color: '#4b5563' }}>
                                        Bạn đang thoát khỏi toàn màn hình. Bấm <b>Bật lại toàn màn hình</b> để quay lại và tiếp tục làm bài.
                                    </div>
                                    <div style={{ marginTop: 10, fontSize: 12, color: '#6b7280' }}>
                                        Mẹo: Nếu trình duyệt chặn, hãy thử bấm lại nút một lần nữa.
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Footer */}
                        <div style={{ padding: '0 24px 20px', display: 'flex', justifyContent: 'flex-end' }}>
                            <Button
                                label="Bật lại toàn màn hình"
                                icon="pi pi-window-maximize"
                                className="p-button"
                                style={{
                                    background: '#23085a',
                                    borderColor: '#23085a',
                                    boxShadow: '0 10px 18px rgba(35, 8, 90, 0.22)'
                                }}
                                onClick={async () => {
                                    try {
                                        const el = document.documentElement;
                                        if (!document.fullscreenElement && el?.requestFullscreen) {
                                            await el.requestFullscreen();
                                        }
                                        if (document.fullscreenElement) {
                                            setShowForceFullscreen(false);
                                        }
                                    } catch (e) {
                                        // Browser có thể chặn — user thử lại
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            )}
            <div style={{ height: '100vh' }}>
                <div style={{ paddingTop: '80px' }}>
                    {!showQuestion ?
                        <>
                            <div className="conatiner-div1">
                                <div>
                                    <h2 className="title">Speaking</h2>
                                </div>
                                <div>
                                    <h2 className="title">Prompt</h2>
                                </div>
                            </div>

                            <div >
                                {
                                    loading
                                        ?
                                        <div style={{ textAlign: 'center' }}>
                                            <ProgressSpinner />
                                        </div>
                                        :
                                        <div className="conatiner-div1" >
                                            <div>
                                                <div className='mb-5'>
                                                    {dataListQuestion.length > 0 &&
                                                        <div dangerouslySetInnerHTML={{ __html: motadau }}>
                                                        </div>
                                                    }
                                                </div>

                                                <div className='mb-5'>
                                                    {fileDinhKem != "" && fileDinhKem != null &&
                                                        <div style={{ marginTop: '20px', width: '100%' }}>
                                                            <audio
                                                                controlsList="nodownload"
                                                                key={indexDF}
                                                                ref={audioRef}
                                                                style={{ display: 'none' }}
                                                                onEnded={() => {
                                                                    setIsPlaying(false);
                                                                    // Phát tiếng bíp ngắn trước khi auto-next
                                                                    try {
                                                                        const beepAudio = new Audio('/images/beep-sound.mp3');
                                                                        beepAudio.onended = () => handleAutoNext();
                                                                        beepAudio.play().catch(() => handleAutoNext());
                                                                    } catch (e) {
                                                                        handleAutoNext();
                                                                    }
                                                                }}
                                                                autoPlay
                                                            >
                                                                <source src={fileDinhKem} type="audio/ogg" />
                                                                <source src={fileDinhKem} type="audio/mpeg" />
                                                            </audio>
                                                        </div>
                                                    }
                                                </div>
                                            </div>

                                            <div style={{ marginBottom: dataListQuestion.length > 0 ? '100px' : '50px' }}>
                                                {dataListQuestion.length > 0 &&
                                                    <div dangerouslySetInnerHTML={{ __html: motacuoi }}>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                }

                            </div>
                        </>
                        :
                        <ExamNoiDetail
                            loading={loading}
                            dataQuestion={dataQuestion}
                            socauhoi={socauhoi}
                            indexDF={indexDF}
                            indexNhom={indexNhom}
                            onSubmitAnswer={onSubmitAnswer}
                            onAutoNext={handleAutoNext}
                        ></ExamNoiDetail>
                    }
                </div>

                <div className='divfooter d-flex justify-content-between'>
                    <div className="menu-container align-items-center d-inline-flex">
                        <button className="btn1"
                            onClick={() => openDetailMenu()}
                        >
                            <span className="mat-button-wrapper">
                                <IoMdMenu size={24} />
                            </span>
                        </button>
                        <button className="btn1"
                            onClick={() => setVisibleInFo(true)}>
                            <span className="mat-button-wrapper">
                                <IoIosInformationCircleOutline size={24} />
                            </span>
                        </button>
                    </div>
                    {/* <div className="nav-container ml-auto align-items-center d-inline-flex">
                        <Button className="btn2 "
                            onClick={() => getCurrentQuestion(arrIdQuestion, indexDF, 'next')}
                            icon={loading ? 'pi pi-spinner pi-spin' : 'pi pi-arrow-right'}
                            label="Next"
                            disabled={loading}
                        >
                        </Button>
                    </div> */}
                </div>
            </div>



            <Navmenudetail
                visible={visible}
                onClose={onCloseDetailMenu}
                type={typeExam}
                socauhoi={sonhomcauhoi}
                arrIdQuestion={arrIdQuestion}
                indexDF={indexNhom}
                openMenuLeft={(val, idx) => openMenuLeft(val, idx)}
            >
            </Navmenudetail>
            <NavInfo
                visible={visibleInFo}
                type={type}
                onClose={() => setVisibleInFo(false)}
            ></NavInfo>

            <ConfirmDialog
                closable={false}
                style={{
                    width: 'min(440px, 95vw)',
                    borderRadius: 16,
                    overflow: 'hidden',
                    boxShadow: '0 20px 60px rgba(35,8,90,0.18)',
                }}
                pt={{
                    header: {
                        style: {
                            padding: '24px 28px 8px',
                            fontSize: 18, fontWeight: 700,
                            color: '#1e1b4b',
                            borderBottom: 'none',
                            background: '#fff',
                        }
                    },
                    content: {
                        style: {
                            padding: '0 28px 20px',
                            background: '#fff',
                        }
                    },
                    footer: {
                        style: {
                            padding: '12px 28px 24px',
                            display: 'flex', justifyContent: 'flex-end',
                            gap: 12, background: '#fff',
                            borderTop: 'none',
                        }
                    },
                    rejectButton: {
                        style: {
                            border: '1.5px solid #d1d5db',
                            color: '#374151',
                            background: '#fff',
                            borderRadius: 8, fontWeight: 600,
                            padding: '10px 24px', minWidth: 110,
                        }
                    },
                    acceptButton: {
                        style: {
                            background: '#23085a',
                            border: '1.5px solid #23085a',
                            color: '#fff',
                            borderRadius: 8, fontWeight: 600,
                            padding: '10px 24px', minWidth: 110,
                        }
                    },
                    closeButton: {
                        style: { display: 'none' }
                    },
                    icon: { style: { display: 'none' } },
                }}
            />
            <Toast ref={toast} />
        </>
    )
}
